import { playerMaxPosture } from './difficulty'

// パリィ長押しガード (docs/superpowers/plans/2026-07-07-parry-hold-guard-prototype.md)。
//   採用確定 (07-09 騎士+覚醒王 A/B G1〜G5 全OK・台帳ピン済) → **2026-07-20 に既定 ON**。
//   台帳の解禁条件「既定ON化は専用アニメ差し替えと同時」= 受け構え (案C) の Spine 清書完了で満たした。
//   __guard(true|false) (main.ts DEVフック) は A/B 用に残す (OFF にすると従来経路と識別不能)。

let enabled = true

export function setGuardEnabled(on: boolean): void {
  enabled = on
}

export function guardEnabled(): boolean {
  return enabled
}

// 2026-09-12 ユーザー裁定: 単発の保険として2発は受けられ、3発目で崩れる。
// 難易度に関わらず同じ回数。体幹ゼロ・途中の回復なしが基準。
// 旧「通常パリィ < ガード < 被弾」の体幹順序より、この回数を優先する。
export const GUARD = {
  chipDamageMul: 0,
  hitsToBreak: 3,
  postureRegenLockSec: 2.5,
} as const

export function guardSelfPostureGain(): number {
  return Math.ceil(playerMaxPosture() / GUARD.hitsToBreak)
}
